export const getInitials = (fullName: string): string => {
  if (!fullName || typeof fullName !== "string") return fullName;
  const names = fullName.split(" ");
  return names
    .filter((s) => Boolean(s))
    .map((p) => p.substring(0, 1).toUpperCase())
    .join("")
    .substring(0, 3);
};
